export default __webpack_public_path__ + "static/media/cauliflower.2f48f51d.png";